import React, { useEffect, useState } from 'react';
import { Button, Input, message, Select, Steps, theme} from 'antd';

import '../build.css'
import { Link } from 'react-router-dom';
const Slide = () => {
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value
  const [sopcourse, setSopcourse] = useState({
    course: "",
    second:"",
    three1:"",
    change: "",
    technology: "",
    isvaildsecond:false,
    isvaildtechnology:false,
    isvaildthree1:true,
    gapenable:false,
    donthaveexprelated:false,
    eductionstream1:false,
    gapinyear:"",
    
 


  });

const onChange = (e) => {
  console.log(e);
  localStorage.setItem("technology", e)
  setSopcourse({
    ...sopcourse,
    technology:e
  })
};

const  onChange3=(e)=>{
  console.log(e);
localStorage.setItem("tree", e)
setSopcourse({
  ...sopcourse,
  three1:e
})
}
// useEffect(() => {
//   if (sopcourse.second === "I don't have experiences similar to those of an undergraduate (Ug)") {
//       setSopcourse(prevState => ({
//           ...prevState,
//           donthaveexprelated: true,
//           isvaildthree1: false, // Reset other flags
//           isvaildtechnology: false,
//           gapenable: false
//       }));
//   } else if (sopcourse.three1 !== "") {
//       setSopcourse(prevState => ({
//           ...prevState,
//           isvaildthree1: !prevState.isvaildthree1,
//           donthaveexprelated: false, // Reset other flags
//           isvaildtechnology: false,
//           gapenable: false
//       }));
//   } else if (sopcourse.technology !== "") {
//       setSopcourse(prevState => ({
//           ...prevState,
//           isvaildtechnology: false,
//           donthaveexprelated: false, // Reset other flags
//           isvaildthree1: false,
//           gapenable: false
//       }));
//   } else if (sopcourse.second === "i don't have experience but have gap") {
//       setSopcourse(prevState => ({
//           ...prevState,
//           gapenable: true,
//           donthaveexprelated: false, // Reset other flags
//           isvaildthree1: false,
//           isvaildtechnology: false
//       }));
//   }
// }, [sopcourse.three1, sopcourse.second, sopcourse.technology]);



 
const  onChangeugNotMatch=(e)=>{
  console.log(e);
// localStorage.setItem("ugnot1", e);
setSopcourse({
  ...sopcourse,
  second: e
});  
}

const handleValueChange = (event) => {
  const { name, value } = event.target;
  setSopcourse({
    ...sopcourse,
    [name]: value
  });  

  

  console.log(sopcourse)
};


useEffect(()=>{

  if(sopcourse.second  === "NoExpMatchUG"){
    setSopcourse({
      ...sopcourse,
      donthaveexprelated: !sopcourse.donthaveexprelated,
    })
  }  

  if(sopcourse.three1  === "stream Change"){
    setSopcourse({
      ...sopcourse,
      eductionstream1: !sopcourse.eductionstream1,
    })
  }  
},[sopcourse.second  ,   sopcourse.three1])

//   const handleValueChange = (event) => {
//     const { name, value } = event.target;
//     setSopcourse({
//       ...sopcourse,
//       [name]: { ...sopcourse[name], value }
//     });
//     if(sopcourse.second  == "Idonthaveexperiencessimilartothoseofanundergraduate(Ug)"){
//       setSopcourse({
//         ...sopcourse,
//         donthaveexprelated:!sopcourse.donthaveexprelated
//       })
//     }else if(event  == "similar to my UG"){
    
//           localStorage.setItem("tree" , "similar to my UG")
     
//     }
  


// // if(value =="idonthaveanyGap"){
// // localStorage.setItem("first" ,value)
// // }else if (value == "idonthaveexperiencebuthavegap"){
// //   localStorage.setItem("second" ,value)
// // }else  if(value == "course"){
// //   localStorage.setItem("thread" ,value)
// // }
// }
console.log(sopcourse)

// useEffect(()=>{
// if(sopcourse.technology.value  != ""){
//   // localStorage.setItem("technolog1" , sopcourse.technology.value)
// }else if(sopcourse.idonthaveanyGap.checked === true ){
//               localStorage.setItem("one" , "idonthaveanyGap");
// }else if(sopcourse.idonthaveexperiencebuthavegap.checked == true){
//                localStorage.setItem("idonthaveexperiencebuthavegap")
// }
// },[])
  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: 'First',
      content: <>
      <div className='formdatasop '>
 

<div className='technology_continer'>

<h4  className='slidedata' style={{marginBottom: '10px',}}>UG Discipline </h4>
  <div class="col"    >
  {/* <select className="form-select" aria-label="Default select example" style={{width:'11rem'}} name='technology' onChange={handleValueChange}>
  <option selected>UG discipline</option>
  <option value="MECH">Mechanical Engineering</option>
  <option value="CSE">CSE Computer Science</option>
  <option value="ECE">Electronics and Communication Engineering</option>
  <option value="EEE">Electrical  and Electrical Engineering</option>
  <option value="CIV">Civil Engineering</option>
  <option value="AGRIC">Agricultural Engineering</option>
  <option value="AE">Aeronautical Engineering</option>
  <option value="AM">Automobile Engineering</option>
  <option value="CHME">Chemical Engineering</option>
</select> */}

<label><strong>Select your  Bachelors Stream</strong> </label>
<br></br>
<Select
    showSearch
    style={{
      width: 230,
      border:'1px solid blue',
      borderRadius: '6px',
      marginTop: '10px',
    }}
    placeholder="Select Your Specification"
    optionFilterProp="children"
    filterOption={(input, option) => (option?.label ?? '').includes(input)}
    filterSort={(optionA, optionB) =>
      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
    }  
       
    onChange={onChange}
    options={[
      {
        value: 'MECH',
        label: 'Mechanical Engineering',
      },
      {
        value: 'CSE',
        label: 'CSE Computer Science',
      },
      {
        value: 'ECE',
        label: 'Electronics and Communication Engineering',
      },
      {
        value: 'CIVE',
        label: 'Civil Engineering',
      },
      {
        value: 'AGRIC',
        label: 'Agricultural Engineering',
      },
      {
        value: 'AE',
        label: 'Aeronautical Engineering',
      },
      {
        value: 'AE',
        label: 'Automobile Engineering',
      },
      {
        value: 'CHME',
        label: 'Chemical Engineering',
      },
    ]}
  />

  </div></div></div></>,
    },
    {
      title: 'Second',
      content: <>
      <div  className='formdata1'>
      <h4 className='slidedata'     style={{marginTop: '50px',}}>Professional Experience</h4>
      <div className='experience'>
      <div class="form-check">

      <input
  className="form-check-input"
  type="radio"
  value="ExpMatchUg"
  name="second"
  id="flexCheckDefault"
  onChange={handleValueChange}
  checked={sopcourse.second === 'ExpMatchUg'} // Ensure casing consistency
/>
<label className="form-check-label" htmlFor="flexCheckDefault">
  I have experience similar to my UG
</label>
  <div>

  <input
        className="form-check-input"
        type="radio"
        value="NoExpMatchUG"
        name="second"
        id="flexCheckDefault"
        onChange={handleValueChange}   
        checked={sopcourse.second === 'NoExpMatchUG'} 
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
        I have Experience which is not similar to my  Bachelor's (UG)
      </label>
</div>   

{sopcourse.donthaveexprelated  && <>
  <label class="form-check-label" for="flexCheckDefault">
  Experiences related to which technology
  </label>
<div>
<Select
    showSearch
    style={{
      width: 200,

      border:'1px solid blue',
      borderRadius: '6px',
    }}
    placeholder="Select Your Specification"
    optionFilterProp="children"
    filterOption={(input, option) => (option?.label ?? '').includes(input)}
    filterSort={(optionA, optionB) =>
      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
    }  

    onChange={onChangeugNotMatch}
    options={[
      {
        value: 'MECH',
        label: 'Mechanical Engineering',
      },
      {
        value: 'CSE',
        label: 'CSE Computer Science',
      },
      {
        value: 'ECE',
        label: 'Electronics and Communication Engineering',
      },
      {
        value: 'CIVE',
        label: 'Civil Engineering',
      },
      {
        value: 'AGRIC',
        label: 'Agricultural Engineering',
      },
      {
        value: 'AE',
        label: 'Aeronautical Engineering',
      },
      {
        value: 'AE',
        label: 'Automobile Engineering',
      },
      {
        value: 'CHME',
        label: 'Chemical Engineering',
      },
    ]}
  />
</div>
</>}
<div>
            {/* <input class="form-check-input" type="radio" value="I don't have any Gap" id="flexCheckDefault"  name='second'   onChange={handleValueChange}/>
  <label class="form-check-label" for="flexCheckDefault">
  I don't have any Gap (No Experience)
  </label> */}
  <input
        className="form-check-input"
        type="radio"
        value="NoGap"
        name="second"
        id="flexCheckDefault"
        onChange={handleValueChange}
        checked={sopcourse.second === 'NoGap'} // Optional: If you want to reflect the current selection
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
      don't have any Eduction  Gap (No Experience)
      </label>
</div>
<div>
         

  <input
        className="form-check-input"
        type="radio"
        value="NOGapNoExp"
        name="second"
        id="flexCheckDefault"
        onChange={handleValueChange}
        checked={sopcourse.second === 'NOGapNoExp'} // Optional: If you want to reflect the current selection
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
           I have Eduction  Gap (No Experience)
      </label>
  </div>
</div>
</div></div>
      </>,
    },
    {
      title: 'Last',
      content: <>
         <div  className='formdata1'>
      <h4 className='graduate-courses mt-4'    style={{marginTop: '1.8rem',}}>Desired Graduate Courses</h4>
      <div className='experience'>
      <div class="form-check">
      <input
        className="form-check-input"
        type="radio"
        value="PgMatchUG"
        name="three1"
        id="flexCheckDefault"
        onChange={handleValueChange}
        checked={sopcourse.three1 === 'PgMatchUG'} // Optional: If you want to reflect the current selection
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
        Similar to my Bachelor (UG)
      </label>
<div>
  <input
        className="form-check-input"
        type="radio"
        value="stream Change"
        name="three1"
        id="flexCheckDefault"
        onChange={handleValueChange}
        checked={sopcourse.three1 === 'stream Change'} // Optional: If you want to reflect the current selection
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
      Stream Change (if you are changing the education stream)
      </label>

  {sopcourse.eductionstream1    &&  <><div><Select
    showSearch
    style={{
      width: 200,
      border:'1px solid blue',
      borderRadius: '6px',
    }}
    placeholder="Select Your Specification"
    optionFilterProp="children"
    filterOption={(input, option) => (option?.label ?? '').includes(input)}
    filterSort={(optionA, optionB) =>
      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
    }  

    onChange={onChange3}
    options={[
      {
        value: 'MECH',
        label: 'Mechanical Engineering',
      },
      {
        value: 'CSE',
        label: 'CSE Computer Science',
      },
      {
        value: 'ECE',
        label: 'Electronics and Communication Engineering',
      },
      {
        value: 'CIVE',
        label: 'Civil Engineering',
      },
      {
        value: 'AGRIC',
        label: 'Agricultural Engineering',
      },
      {
        value: 'AE',
        label: 'Aeronautical Engineering',
      },
      {
        value: 'AE',
        label: 'Automobile Engineering',
      },
      {
        value: 'CHME',
        label: 'Chemical Engineering',
      },
    ]}
  /></div></>}
  
</div>
<div>

    <input
        className="form-check-input"
        type="radio"
        value="MatchJobExp"
        name="three1"
        id="flexCheckDefault"
        onChange={handleValueChange}
        checked={sopcourse.three1 === 'MatchJobExp'} // Optional: If you want to reflect the current selection
      />
      <label className="form-check-label" htmlFor="flexCheckDefault">
      Similar  to job Experiences
      </label>
  {/* <div><Select
    showSearch
    style={{
      width: 200,      
      border:'1px solid blue',
      borderRadius: '6px',
    }}
    placeholder="Select Your Specification in Technology"
    optionFilterProp="children"
    filterOption={(input, option) => (option?.label ?? '').includes(input)}
    filterSort={(optionA, optionB) =>
      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
    }  

    onChange={onChange3}
    options={[
      {
        value: 'MECH',
        label: 'Mechanical Engineering',
      },
      {
        value: 'CSE',
        label: 'CSE Computer Science',
      },
      {
        value: 'ECE',
        label: 'Electronics and Communication Engineering',
      },
      {
        value: 'CIVE',
        label: 'Civil Engineering',
      },
      {
        value: 'AGRIC',
        label: 'Agricultural Engineering',
      },
      {
        value: 'AE',
        label: 'Aeronautical Engineering',
      },
      {
        value: 'AE',
        label: 'Automobile Engineering',
      },
      {
        value: 'CHME',
        label: 'Chemical Engineering',
      },
    ]}
  /></div> */}
  </div>
</div>
</div></div></>,
    },
  ];
      
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 18,
        }}
      >
        {current < steps.length - 1 && (
          <Button type="primary" disabled={sopcourse.isvaildtechnology} onClick={() => next()}  style={{margin: '16px'}}>
            Next
          </Button>
        )}
        {current === steps.length - 1 && (
          <Link to="/buildFilter" ><Button type="primary" onClick={() => {message.success(`Processing complete! Input: ${inputValue}`);
          localStorage.setItem("technology",sopcourse.technology);
          localStorage.setItem("second",sopcourse.second);
          localStorage.setItem("tree",sopcourse.three1);
          }}>
            Done
          </Button>           </Link>
        )}
        {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}
      </div>
    </>
  );
};

export default Slide;
